import validate from "/tmp/server_www/node_modules/nuxt/dist/pages/runtime/validate.js";
import unknown_45path_45global from "/tmp/server_www/app_layers/allsports/middleware/unknown-path.global.ts";
import manifest_45route_45rule from "/tmp/server_www/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  unknown_45path_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}